import React from "react";
import styled from "styled-components";
import Layout from "../Layout/Layout";

export default function IndiverseFinalists() {
  const winners = {
    first: {
      name: "Oishi Sengupta",
      college: "Scottish Church College",
      prize: "Cash prize of Rs - 2500",
      title: "Title : 'IndiVerse Laureate'",
    },
    firstRunnerUp: {
      name: "Tejasvee Nagar",
      college: "Sophia College",
      title: "Title : 'IndiVerse Luminary'",
    },
    secondRunnerUp: {
      name: "Aman Gupta",
      college: "Smt.Chandibai Himmatmal Mansukhani College",
      subtitle: "Congratulations",
    },
  };

  const finalists = [
    {
      name: "Laxmi Gaur",
      college: "Smt.Chandibai Himmatmal Mansukhani College",
    },
    { name: "Asavi Kapadia", college: "Jai Hind College" },
    {
      name: "Kajorika Chakraborty",
      college: "Smt Chandibai Himathmal Mansukhani college",
    },
    { name: "Oishi Sengupta", college: "Scottish Church College" },
    { name: "Rizpah Samson", college: "Christ Church Jr Collage" },
    { name: "Rushika Patel", college: "Pandit Deendayal Energy University" },
    { name: "Violet D'souza", college: "St. Teresa's Institute Of Education" },
    {
      name: "Aman Gupta",
      college: "Smt.Chandibai Himmatmal Mansukhani College",
    },
    {
      name: "Gayatri Sunilkumar",
      college: "Kishinchand Chellaram Law College",
    },
    { name: "Anushri Maigonkar", college: "Hislop College" },
    {
      name: "Carol Fernando",
      college: "Smt.Chandibai Himmatmal Mansukhani College",
    },
    {
      name: "Kritarth Jain",
      college: "R.A. Podar College Of Commerce And Economics",
    },
    {
      name: "Yannichristy Anthony",
      college: "SICES Society's Degree College Of Arts, Science And Commerce",
    },
    {
      name: "Pratiksha Prabhu",
      college: "Smt.Chandibai Himmatmal Mansukhani College",
    },
    {
      name: "Ashirwad Das",
      college: "School Of Creative Studies, D.Y. Patil University",
    },
    { name: "Tejasvee Nagar", college: "Sophia College" },
  ];

  return (
    <Layout>
      <PageWrapper>
        <Root>
          <Container>
            <Header>
              <MainTitle>INDIVERSE</MainTitle>
              <Subtitleone>
                All India Inter Collegiate Poetry Competition
              </Subtitleone>
              <Subtitle>GRAND FINALE</Subtitle>
            </Header>

            <WinnersSection>
              <SectionTitle>WINNERS</SectionTitle>

              <WinnersGrid>
                <WinnerCard>
                  <Position>First</Position>
                  <WinnerName>{winners.first.name}</WinnerName>
                  <College>{winners.first.college}</College>
                  <Prize>{winners.first.prize}</Prize>
                  <Title>{winners.first.title}</Title>
                </WinnerCard>

                <WinnerCard>
                  <Position>First Runner Up</Position>
                  <WinnerName>{winners.firstRunnerUp.name}</WinnerName>
                  <College>{winners.firstRunnerUp.college}</College>
                  <Title>{winners.firstRunnerUp.title}</Title>
                </WinnerCard>

                <WinnerCard>
                  <Position>Second Runner Up</Position>
                  <WinnerName>{winners.secondRunnerUp.name}</WinnerName>
                  <College>{winners.secondRunnerUp.college}</College>
                  <Subtitle2>{winners.secondRunnerUp.subtitle}</Subtitle2>
                </WinnerCard>
              </WinnersGrid>

              <SponsorText>
                Above winners would be Sponsored by Purple Prose, Bits Pilani
                for travel and accommodation for participation in Finals during
                Bits Pilani's Oasis'25 .
              </SponsorText>
            </WinnersSection>

            <FinalistsSection>
              <SectionTitle>FINALISTS</SectionTitle>

              <FinalistsGrid>
                {finalists.map((finalist, idx) => (
                  <FinalistCard key={idx}>
                    <FinalistName>{finalist.name}</FinalistName>
                    <FinalistCollege>{finalist.college}</FinalistCollege>
                  </FinalistCard>
                ))}
              </FinalistsGrid>
            </FinalistsSection>

            <VideoSection>
              <VideoTitle>GRAND FINALE - VIDEO</VideoTitle>
              <VideoWrapper>
                <iframe
                  credentialless="true"
                  width="100%"
                  height="100%"
                  src="https://www.youtube.com/embed/QToOfVWOzRM"
                  title="IndiVerse Grand Finale"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </VideoWrapper>
            </VideoSection>
          </Container>
        </Root>
      </PageWrapper>
    </Layout>
  );
}

const PageWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
`;

const Root = styled.div`
  min-height: 100vh;
  height: auto;
  background-color: var(--color-background);
  color: var(--color-text);
  display: flex;
  max-width: 1300px;
  width: 100%;
`;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 40px 20px;
  gap: 40px;

  @media (max-width: 768px) {
    padding: 30px 16px;
    gap: 30px;
  }

  @media (max-width: 480px) {
    padding: 20px 12px;
    gap: 24px;
  }
`;

const Header = styled.div`
  text-align: center;
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 768px) {
    padding-bottom: 16px;
  }
`;

const MainTitle = styled.h1`
  color: var(--color-text);
  font-size: 48px;
  font-weight: 700;
  margin: 0 0 12px 0;
  letter-spacing: 8px;

  @media (max-width: 768px) {
    font-size: 36px;
    letter-spacing: 6px;
  }

  @media (max-width: 480px) {
    font-size: 28px;
    letter-spacing: 4px;
  }
`;

const Subtitleone = styled.h2`
  color: var(--color-text);
  font-size: 28px;
  font-weight: 600;
  margin: 0;
  letter-spacing: 2px;
  margin-bottom: 14px;
  padding-bottom: 10px;
  border-bottom: 2px solid var(--color-border);
  display: inline-block;

  @media (max-width: 768px) {
    font-size: 22px;
  }

  @media (max-width: 480px) {
    font-size: 18px;
  }
`;

const Subtitle = styled.h2`
  color: var(--color-text);
  font-size: 28px;
  font-weight: 600;
  margin: 0;
  letter-spacing: 2px;
  padding-bottom: 12px;
  border-bottom: 2px solid var(--color-border);
  display: inline-block;

  @media (max-width: 768px) {
    font-size: 22px;
  }

  @media (max-width: 480px) {
    font-size: 18px;
  }
`;

const WinnersSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const SectionTitle = styled.h3`
  color: var(--color-text);
  font-size: 32px;
  font-weight: 700;
  margin: 0;
  text-align: center;
  padding-bottom: 12px;
  border-bottom: 2px solid var(--color-border);
  display: inline-block;
  align-self: center;

  @media (max-width: 768px) {
    font-size: 26px;
  }

  @media (max-width: 480px) {
    font-size: 22px;
  }
`;

const WinnersGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;

  @media (max-width: 968px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
`;

const WinnerCard = styled.div`
  background-color: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  text-align: center;

  @media (max-width: 480px) {
    padding: 20px 16px;
  }
`;

const Position = styled.div`
  color: var(--color-text);
  font-size: 20px;
  font-weight: 700;
  text-decoration: underline;
  margin-bottom: 4px;

  @media (max-width: 768px) {
    font-size: 18px;
  }

  @media (max-width: 480px) {
    font-size: 16px;
  }
`;

const WinnerName = styled.div`
  color: var(--color-text);
  font-size: 24px;
  font-weight: 700;

  @media (max-width: 768px) {
    font-size: 20px;
  }

  @media (max-width: 480px) {
    font-size: 18px;
  }
`;

const College = styled.div`
  color: var(
    --color-text-tertiary,
    var(--color-text-secondary, var(--color-text))
  );
  font-size: 16px;
  line-height: 1.4;

  @media (max-width: 768px) {
    font-size: 14px;
  }

  @media (max-width: 480px) {
    font-size: 13px;
  }
`;

const Prize = styled.div`
  color: var(--color-text-secondary, var(--color-text));
  font-size: 16px;
  font-weight: 600;
  margin-top: 4px;

  @media (max-width: 768px) {
    font-size: 14px;
  }

  @media (max-width: 480px) {
    font-size: 13px;
  }
`;

const Title = styled.div`
  color: var(--color-text-secondary, var(--color-text));
  font-size: 16px;
  font-weight: 600;

  @media (max-width: 768px) {
    font-size: 14px;
  }

  @media (max-width: 480px) {
    font-size: 13px;
  }
`;

const Subtitle2 = styled.div`
  color: var(--color-text-secondary, var(--color-text));
  font-size: 16px;
  font-weight: 600;

  @media (max-width: 768px) {
    font-size: 14px;
  }

  @media (max-width: 480px) {
    font-size: 13px;
  }
`;

const SponsorText = styled.p`
  color: var(--color-text-tertiary, var(--color-text));
  font-size: 18px;
  text-align: center;
  line-height: 1.6;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 14px;
  }

  @media (max-width: 480px) {
    font-size: 13px;
  }
`;

const FinalistsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const FinalistsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

const FinalistCard = styled.div`
  background-color: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  text-align: center;

  @media (max-width: 480px) {
    padding: 14px 16px;
  }
`;

const FinalistName = styled.div`
  color: var(--color-text);
  font-size: 18px;
  font-weight: 700;

  @media (max-width: 768px) {
    font-size: 16px;
  }

  @media (max-width: 480px) {
    font-size: 15px;
  }
`;

const FinalistCollege = styled.div`
  color: var(
    --color-text-tertiary,
    var(--color-text-secondary, var(--color-text))
  );
  font-size: 14px;
  line-height: 1.4;

  @media (max-width: 768px) {
    font-size: 13px;
  }

  @media (max-width: 480px) {
    font-size: 12px;
  }
`;

const VideoSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const VideoTitle = styled.h3`
  color: var(--color-text);
  font-size: 32px;
  font-weight: 700;
  margin: 0;
  text-align: center;
  padding-bottom: 12px;
  border-bottom: 2px solid var(--color-border);

  @media (max-width: 768px) {
    font-size: 26px;
  }

  @media (max-width: 480px) {
    font-size: 22px;
  }
`;

const VideoWrapper = styled.div`
  width: 100%;
  height: 400px;
  background-color: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  overflow: hidden;

  @media (max-width: 968px) {
    height: 350px;
  }

  @media (max-width: 768px) {
    height: 300px;
  }

  @media (max-width: 480px) {
    height: 220px;
  }

  iframe {
    display: block;
  }
`;
